import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { TRANSLATIONS } from "@/i18n/dictionary";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("rplc_lang") || "en";
  });

  const t = useMemo(() => TRANSLATIONS[lang] || TRANSLATIONS.en, [lang]);
  const dir = t.dir;

  useEffect(() => {
    document.documentElement.setAttribute("lang", t.lang);
    document.documentElement.setAttribute("dir", dir);
    document.body.dataset.lang = t.lang;
    localStorage.setItem("rplc_lang", lang);
  }, [lang, dir, t.lang]);

  const toggle = useCallback(() => setLang((l) => (l === "en" ? "ar" : "en")), []);
  const setLanguage = useCallback((code) => setLang(code), []);

  const value = useMemo(() => ({ lang, t, dir, toggle, setLanguage }), [lang, t, dir, toggle, setLanguage]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside <LangProvider>");
  return ctx;
}
